import { useCallback, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import storeSelectors from 'modules/store/services/selectors';
import action from 'modules/store/services/actions';

const useGetAllStores = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const allStores = storeSelectors.getAllStores();

  const mutate = useCallback(() => {
    dispatch(action.getAllStores.fetch());
  }, [dispatch]);

  useEffect(() => {
    if (isLazy && allStores?.content.length >= 0) return;
    mutate();
  }, []);

  return {
    stores: allStores?.content || [],
    mutate,
  };
};

export default useGetAllStores;
